// Whether a parked deal belongs IN the review surfaces (Quote Requested + the
// assessment queue) rather than hidden from them.
//
// Mirrors the worker's hiddenFromQueues (prismQuotes.js): `more_info_requested`
// means waiting on the CUSTOMER — hidden by design. Every other parked reason is
// an ENGINE park (NO_MARKET_DATA, IDENTITY_MATCH_FAILED): the engine gave up, a
// human must take over, and hiding those from review is how TI-81F79 vanished
// from both surfaces (2026-07-28). The string is duplicated from the worker's
// MORE_INFO_PARK_REASON — the frontend cannot import worker modules.
const MORE_INFO_PARK_REASON = 'more_info_requested';

export function isParkedForReview(deal) {
    return !!(deal?.excluded_from_pricing_queue && deal?.excluded_reason !== MORE_INFO_PARK_REASON);
}

// The complement: parked specifically because we asked the customer for more info and
// are waiting on THEM. These are hidden from both queues, so the only way back is the
// deal modal's un-park button (POST /api/deals/:id/clear-more-info-park).
export function isMoreInfoParked(deal) {
    return !!(deal?.excluded_from_pricing_queue && deal?.excluded_reason === MORE_INFO_PARK_REASON);
}

// Short operator-facing label for a park reason: the machine prefix without the
// sentence that follows ("NO_MARKET_DATA: engine priced…" → "NO MARKET DATA").
export function parkReasonLabel(reason) {
    if (!reason) return 'Parked';
    const head = String(reason).split(':')[0].trim();
    return head.replace(/_/g, ' ');
}
